const topics = [
  { id: 1, name: '狂飙大结局', heat: '128万', icon: 'ri-fire-line' },
  { id: 2, name: '庆余年第三季', heat: '96万', icon: 'ri-chat-1-line' },
  { id: 3, name: '繁花沪语版', heat: '83万', icon: 'ri-chat-1-line' },
  { id: 4, name: '长相思虐心名场面', heat: '71万', icon: 'ri-fire-line' },
  { id: 5, name: '古装剧推荐', heat: '65万', icon: 'ri-thumb-up-line' },
  { id: 6, name: '国产悬疑天花板', heat: '58万', icon: 'ri-chat-1-line' },
  { id: 7, name: '2025必追剧单', heat: '52万', icon: 'ri-thumb-up-line' },
  { id: 8, name: '张译演技封神', heat: '47万', icon: 'ri-fire-line' },
  { id: 9, name: '仙侠剧颜值天花板', heat: '43万', icon: 'ri-chat-1-line' },
];

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            话题热议
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            剧迷们正在激烈讨论的热门话题，加入追剧大家庭
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href="#hero"
              className="flex items-center gap-3 bg-background-50 rounded-xl px-4 py-3.5 border border-background-200/70 hover:border-accent-300/50 transition-all cursor-pointer group"
            >
              <div className="w-9 h-9 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-200 transition-colors">
                <i className={`${topic.icon} text-sm text-accent-600`}></i>
              </div>
              <span className="text-sm text-foreground-800 truncate flex-1 whitespace-nowrap">
                #{topic.name}
              </span>
              <span className="text-xs text-accent-600 whitespace-nowrap flex-shrink-0">
                {topic.heat}讨论
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}